module.exports = __webpack_public_path__ + "static/img/img_no_permission.0ffb237b.png";